import { styled } from '@abyss/web/tools/styled';
import { Layout } from '@abyss/web/ui/Layout';

export const StyledNetworkAffiliationContainer = styled(Layout.Stack, {
  marginBottom: '-8px !important',
});

export const StyledAffiliationCard = styled('div', {
  backgroundColor: 'white',
  borderRadius: '12px',
  border: '1px solid $gray3',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.05)',
  padding: '16px',
  transition: 'border-color 0.2s',
  '&:hover': {
    borderColor: '$primary1',
  },
  variants: {
    selected: {
      true: {
        border: '2px solid $primary1',
        boxShadow: '0px 3px 6px 0px rgba(0, 0, 0, 0.15)',
      },
    },
    readOnly: {
      true: {
        '&:hover': {
          borderColor: '$primary1',
        },
      },
    },
  },
});

export const StyledAffiliationDetailsWrapper = styled('div', {
  marginLeft: '28px',
});

export const StyledEnrollmentIdWrapper = styled('span', {
  lineHeight: 0,
});

export const StyledViewListPopoverWrapper = styled('div', {
  marginTop: '-2px',
  marginLeft: 2,
});

export const StyledMedicalGroupsList = styled('ul', {
  listStyle: 'unset',
  marginLeft: '16px',
});

export const StyledRadioGroupWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  '.abyss-radio-root': {
    padding: '0',
  },
});
